import Vue from 'vue';
import Vuex from 'vuex';

import AuthModule from '@/store/modules/auth.module.';
import CrewModule from '@/store/modules/crew.module.';
import PaginationModule from '@/store/modules/pagination.module.';
import CircularIssueModule from "@/store/modules/circular/circular_issue.module";
import CircularCategoryModule from "@/store/modules/circular/circular_category.module";
import CircularModule from "@/store/modules/circular/circular.module";
import CustomPaginationModule from "@/store/modules/custom-pagination.module";
import CircularAttachmentModule from "@/store/modules/circular/circular_attachment.module";
import ManningModule from '@/store/modules/manning.module';
import ReportModule from "@/store/modules/report.module";
import createdPersistedState from 'vuex-persistedstate';
import {KRBS_CIRCULARS_APP} from '@/config/constants.config';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLoading: false,
  },
  getters: {
    isLoading: state => state.isLoading,
  },

  mutations: {
    set_is_loading: (state, payload) => {
      state.isLoading = payload;
    },
  },

  actions: {},

  modules: {
    AuthModule,
    CrewModule,
    PaginationModule,
    CircularIssueModule,
    CircularCategoryModule,
    CircularModule,
    CustomPaginationModule,
    CircularAttachmentModule,
    ManningModule,
    ReportModule
  },

  plugins: [
    createdPersistedState({
      key: KRBS_CIRCULARS_APP.ENCRYPTED_DATA,
      storage: window.localStorage,
      paths: [
        'AuthModule.authUser',
        'AuthModule.expiredAt',
        'AuthModule.currentDate',

      ],
    }),
  ],

});
